<template>
<div>
  <services ref = "services"></services>
  <map-view ref = "map"> </map-view>
  <reviews></reviews>
</div>
</template>

<script>

import {store} from '../store.js';

import Reviews from './Reviews.vue'
import Services from './Services.vue'
import MapView from './Map.vue'

export default {
  name: 'ClientPage',
  components: {
    Reviews,
    Services,
    MapView
  },
  computed: {
    scrollCheck () {
      return store.state.refToScroll;
    }
  },
  watch: {
    scrollCheck(){
      this.checkScroll();
    }
  },
  methods: {
    toServices: function(){
      var top = this.$refs.services.$el.offsetTop;
      window.scrollTo(0, top);
    },
    toMap: function(){
      var top = this.$refs.map.$el.offsetTop;
      window.scrollTo(0, top);
    },
    checkScroll: function(){
      let scrollState = store.state.refToScroll;
      if(scrollState == "map"){
        this.toMap();
      } else if (scrollState == "services"){
        this.toServices();
      }

      store.commit('setRefToScroll', "")
    }
  },
  beforeRouteUpdate: function(to,from,next){
    next();
    this.checkScroll();
  },
  mounted: function(){
    this.checkScroll();
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
</style>
